import request from '@/http/request'

export const getSpecialSkuReportPageReport = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/special-sku-reports/pageReport`,
    params
  )
}

export const getSpecialSkuReportSummary = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/special-sku-reports/summaryByParams`,
    params
  )
}

export const getSpecialSkuReportExport = params => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/rfid-report-service/special-sku-reports/exportReport`,
    params,
    {
      responseType: 'blob',
      uploadOrDownload: true
    }
  )
}
